import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useContext } from "react";
import { administratorMethods } from "../api/apiMethods";
import { genericErrorConfig } from "../common/exceptions";
import { ModalContext } from "../components/Modal";
import useSelectedMunicipalityId from "../hooks/useSelectedMunicipalityId";
import { queryKeys } from "../queries/queryKeys";
import { Logger } from "../utils/logger/Logger";

export const useDeleteAdministratorMutation = (options: {
    onSuccess: () => void;
}) => {
    const municipalityId = useSelectedMunicipalityId();
    const { setModalOptions } = useContext(ModalContext);
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: ({ administratorId }: { administratorId?: string }) => {
            if (!municipalityId) {
                throw new Error("No municipality Id");
            }

            if (!administratorId) {
                throw new Error("No administrator id");
            }

            return administratorMethods(municipalityId).deleteAdministrator(
                administratorId
            );
        },
        onSuccess: (_data, variables) => {
            queryClient.invalidateQueries({
                queryKey: queryKeys.administrator.byId(
                    municipalityId,
                    variables.administratorId
                ),
            });
            options.onSuccess();
        },
        onError: (err) => {
            Logger.error(err);
            setModalOptions(
                genericErrorConfig(() => {
                    setModalOptions({ visible: false });
                }, "Kunde inte ta bort administratör.")
            );
        },
        onSettled: () => {
            queryClient.invalidateQueries({
                queryKey: queryKeys.administrator.all(municipalityId),
            });
            queryClient.invalidateQueries({
                queryKey: queryKeys.orderer.all(municipalityId),
            });
        },
    });

    return mutation;
};
